import { Component, inject } from '@angular/core';
import { PaymentTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PaymentTypeCreateDto,
  PaymentTypeDto,
  PaymentTypeExcelDownloadDto,
  PaymentTypeUpdateDto,
} from '../proxy/controlling/dtos/payment-type';
import { PAYMENTTYPE_CONFIG, PAYMENTTYPE_FIELDS } from './payment-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-payment-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PaymentTypeService, ConfirmationService],
  templateUrl: './payment-type.html',
  styleUrl: './payment-type.scss',
})
export class PaymentType extends BaseCrudComponent<
  PaymentTypeDto,
  PaymentTypeCreateDto,
  PaymentTypeUpdateDto,
  PaymentTypeExcelDownloadDto
> {
  service = inject(PaymentTypeService);
  config = PAYMENTTYPE_CONFIG;
  fields = PAYMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PaymentTypeDto): PaymentTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      validate: data.validate,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PaymentType';
  }
}
